import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'

import { ReactComponent as MapPin } from '../../../assets/icons/map-pin.svg'
import { addressPropTypes } from '../../../common/propTypes'
import Address from '../../../ui/components/Address'

import styles from './styles'

const AddressSection = ({ title, data, children, isDestination }) => {
  return (
    <Box
      sx={{
        ...styles.addressSection,
        ...(isDestination ? styles.addressSectionIsDestination : {}),
      }}
    >
      <Typography variant="h2" color="neutral.black">
        {title}
      </Typography>
      <Box sx={styles.addressSectionAddressWrapper}>
        <MapPin />
        <Address data={data} isShippingSend sx={styles.addressSectionAddress} />
      </Box>
      {children}
    </Box>
  )
}

AddressSection.propTypes = {
  title: PropTypes.string,
  data: addressPropTypes,
  children: PropTypes.node,
  isDestination: PropTypes.bool,
}

export default AddressSection
